import React from 'react';
import Filters from '../filters/Filters';
import Search from '../filters/Search';
import AccessibleOnly from '../filters/AccessibleOnly';
import ViewMapButton from './ViewMapButton'


const MapFilterPanel = (props) => {

  return (
    <>
      <ViewMapButton handleToggleFilter={props.handleToggleFilter} />
      <h2>Sydney Olympic Park</h2>

        <>
        <Search map={props.map} setShowOnlyAccessible={props.setShowOnlyAccessible} mapSettings={props.mapSettings} setFiltersActive={props.setFiltersActive} setActivePins={props.setActivePins} data={props.mapData.pins} categories={props.mapData.categories} testForAccessibility={props.testForAccessibility} />
          <AccessibleOnly map={props.map} setShowOnlyAccessible={props.setShowOnlyAccessible} showOnlyAccessible={props.showOnlyAccessible} />
          <Filters map={props.map} initialLoad={props.initialLoad} filterType="categories" setActiveFilter={props.setActiveFilter} initiallyActive={[]} filterData={props.mapData.categories} filterPins={props.filterPins} setClosureActive={props.setClosureActive} closureActive={props.closureActive} setClosureDetails={props.setClosureDetails} />
          <Filters map={props.map} initialItems={props.initialLoad} filterType="venues" setActiveFilter={props.setActiveFilter} initiallyActive={false} filterData={props.mapData.venues} filterPins={props.filterPins} setClosureActive={props.setClosureActive} closureActive={props.closureActive} setClosureDetails={props.setClosureDetails} />
        </>
    </>
  )
}

export default MapFilterPanel
